import { ArrowUpRight, Cpu, Timer, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import type { MinerProduct } from "../api/models";
import { formatUsd } from "../utils/money";
import { useCopy } from "../i18n/copy";
import { Countdown } from "./Countdown";

export function ProductCard({ product }: { product: MinerProduct }) {
  const { tr } = useCopy();
  return (
    <article className="product-card">
      <div className="product-visual">
        {product.badge && (
          <span className="product-badge">{tr(product.badge)}</span>
        )}
        {product.image ? (
          <img
            src={product.image}
            alt={`${tr("Equipo")} ${product.name}`}
            width="240"
            height="180"
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        ) : (
          <span className="product-image-placeholder">
            <Cpu />
          </span>
        )}
        <span className="power-pill">
          <Zap size={14} /> {product.power} TH/s
        </span>
      </div>
      <div className="product-body">
        <Countdown finishAt={product.finishAt} compact />
        <div>
          <p className="eyebrow">
            {tr(
              product.category === "cloud"
                ? "Computación en la nube"
                : "Equipo de minería",
            )}
          </p>
          <h3>{product.name}</h3>
        </div>
        <div className="product-metrics">
          <span>
            <strong>{formatUsd(product.dailyIncome)}</strong>
            <small>{tr("Ingreso diario")}</small>
          </span>
          <span>
            <strong>
              {product.days} {tr("días")}
            </strong>
            <small>{tr("Duración")}</small>
          </span>
        </div>
        <div className="product-footer">
          <span>
            <small>{tr("Desde")}</small>
            <strong>{formatUsd(product.price)}</strong>
          </span>
          <Link
            className="circle-link"
            to={`/market/${product.id}`}
            aria-label={`${tr("Ver")} ${product.name}`}
          >
            <ArrowUpRight size={21} />
          </Link>
        </div>
      </div>
    </article>
  );
}

export function MinerIllustration({
  tone = "blue",
}: {
  tone?: "blue" | "green" | "gold";
}) {
  return (
    <div className={`miner-illustration tone-${tone}`} aria-hidden="true">
      <Cpu />
      <i />
      <Timer className="mini-timer" />
    </div>
  );
}
